var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field form-filex"},[_c('div',{staticClass:"form-label"},[_c('label',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('div',{staticClass:"form-input"},[_c('div',{staticClass:"form-input-wrapper"},[(_vm.uniqueId)?_c('div',{staticClass:"form-file-upload"},[_c('input',{staticClass:"input",attrs:{"type":"file","id":_vm.uniqueId},on:{"change":function($event){return _vm.upload($event)}}})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574b7545","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/FileImport.vue
// module id = 885
// module chunks = 0